import { Dialog } from '@material-ui/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Input, Label } from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import CloseIcon from '@material-ui/icons/Close';

import { baseUrl } from '../../helpers/EncryptionHelper';
import useEnterKeyListener from '../../helpers/useEnterKeyListener';

const AddWordType = ({
  data,
  visible,
  handleClose,
  Transition,
  editWordType,
}) => {
  const [word, setWord] = useState('');

  function handleValidation() {
    let errorText;
    if (!word) {
      errorText = 'Please enter WordType';
    }
    if (errorText) {
      toastr.error(errorText, 'Error!');
    } else {
      handleAddEditWordType(editWordType);
    }
  }

  function handleAddEditWordType(isEdit) {
    let endpoint = isEdit
      ? `/part-of-speech/${data?.word_type_id || data?._id}`
      : '/part-of-speech';
    let axiosMethod = isEdit ? axios.put : axios.post;
    axiosMethod(baseUrl + endpoint, {
      word_type_name: word,
      name: word,
    })
      .then((res) => {
        toastr.success(
          `WordType ${isEdit ? 'Edited' : 'Added'} Successfully`,
          'Success'
        );
        window.location.reload(false);
      })
      .catch((error) => {
        toastr.error(`WordType ${isEdit ? 'Edit' : 'Add'} Failed`, 'Error!');
      });
  }

  useEnterKeyListener({
    querySelectorToExecuteClick: '#addWordTypeSubmit',
  });

  useEffect(() => {
    if (data) {
      setWord(data?.word_type_name || data?.name);
    }
  }, [data]);
  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <div style={{ width: 400, padding: 40 }}>
        <CloseIcon
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            cursor: 'pointer',
          }}
          onClick={handleClose}
        />
        <div className='mb-3'>
          <Label className='form-label' htmlFor='formrow-firstname-input'>
            Name
          </Label>
          <Input
            id='wordTypeInput'
            type='text'
            className='form-control'
            value={word}
            disabled={data && !editWordType}
            onChange={(e) => setWord(e.target.value)}
            onFocus={() => (window.focusedInput = 'wordTypeInput')}
          />
        </div>
        {!(data && !editWordType) && (
          <div className='mt-4'>
            <Button
              id='addWordTypeSubmit'
              type='button'
              color='primary'
              variant='contained'
              className='w-md'
              onClick={() => {
                handleValidation();
              }}
            >
              Submit
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AddWordType;
